import React, {useState,useEffect} from 'react'
import {localestr} from '../utils'

export default function Modifiers({value,setValue,setModal,data}){
    const [val, setVal] = useState((value||[]).map(el=>el.id))

    const modSorting=(a, b)=>{ //сортування модифікаторів 
        if(a.sorting<b.sorting) return -1
        if(a.sorting>b.sorting) return 1
        if(a.name<b.name) return -1
        if(a.name>b.name) return 1
        return 0
    }
    
    const modCheckItem=(grp,itm)=>{  //Позначки
        if(grp&&grp.type===1){
            let new_val=val.filter(el=>grp.child.findIndex(it=>it.id===el)===-1)
            new_val.push(itm.id)
            setVal(new_val)
        } else {
            const idx=val.findIndex(el=>el===itm.id)
            let new_val=[...val]
            if(idx===-1) new_val.push(itm.id)
            else new_val.splice(idx,1)
            setVal(new_val)
        }
    }

    const retValue=()=>{
        let new_val=[]
        data.forEach(grp => {
            if(grp.type<2){
                if(grp.child) grp.child.forEach(itm=>{if(val.findIndex(el=>el===itm.id)!==-1) new_val.push({...itm})})
            }
            else if(val.findIndex(el=>el===grp.id)!==-1) new_val.push({...grp})
        })
        setValue(new_val)
        setModal(null)
    }

    useEffect(() => {
        if(!val.length){  //заповнити початкові позначки
            let new_val=[]
            data.forEach(grp => {
                if(grp.type<2){
                    if(grp.child) grp.child.forEach(itm=>{if(itm.type===3) new_val.push(itm.id)})
                }
                else if(grp.type===5) new_val.push(grp.id)
                
            })
            setVal(new_val)
        }
        // eslint-disable-next-line
    },[])

    let tmpData=[]
    if(data) tmpData=[...data]
    tmpData.sort(modSorting)
    const modCont=tmpData.map((grp,i)=>{
        let modItems=null
        let chlData=[]
        if(grp.child) chlData=[...grp.child]
        chlData.sort(modSorting)
        if(grp.type<2){
            modItems=chlData.map((el,k)=>{
                const checked=val.find(itm=>itm===el.id)
                let price=null
                if(el.price>0) price=<div style={{padding:'0px 0px 0px 8px',fontStyle:'italic'}}>{localestr('ціна ')+'+'+el.price}</div>
                else if(el.price<0) price=<div style={{padding:'0px 0px 0px 8px',fontStyle:'italic'}}>{localestr('ціна ')+el.price}</div>
                return(<div key={i+'id'+k} style={{padding:'4px 4px 4px 16px',display:'flex'}}>
                    <div style={{flexGrow:'200'}}><input id={i+'id'+k} type={grp.type?'radio':'checkbox'} checked={checked?1:0} onChange={()=>{modCheckItem(grp,el)}} />
                    <label htmlFor={i+'id'+k}>{el.name}</label></div>{price}
                    </div>)
            } 
            )
            return(<div key={i} style={{border:'1px solid #0008',borderRadius:'5px',marginTop:'3px'}}>
                <div style={{display:'flex',height:'24px',fontWeight:'bold'}}><div style={{paddingLeft:'2px',flexGrow:'200'}}>{grp.name}</div><div style={{paddingLeft:'10px'}}>
                </div></div>{modItems}</div>
            )
        }
        else {
            const checked=val.find(itm=>itm===grp.id)
            let price=null
            if(grp.price>0) price=<div>{localestr('ціна ')+'+'+grp.price}</div>
            else if(grp.price<0) price=<div>{localestr('ціна ')+grp.price}</div>
            return(
                <div key={i} style={{paddingLeft:'20px',fontStyle:'italic',display:'flex'}}>
                        <div style={{flexGrow:'200'}}><input id={i} type='checkbox' checked={checked?1:0} onChange={()=>{modCheckItem(null,grp)}} />
                        <label htmlFor={i}>{grp.name}</label></div>{price}</div>
        )}                
    })



    return(
        <div className='modal'><div className='window'>
            <div style={{flexDirection:'row',display:'flex',justifyContent:'flex-start'}}><div className='caption'>{localestr('Вибір модифікаторів')}</div><div className='closebtn' onClick={()=>{retValue()/*setModal('')*/}}/></div>
            <div className='content'>
                {modCont}

            <div style={{margin:'4px 0 0 0',display:'flex',justifyContent:'center'}}>
                <div style={{width:'80px',height:'32px',display:'inline-block',verticalAlign:'bottom'}} className={'ord_button2 toolBarItem toolBarItem2'} onClick={()=>retValue()}><div style={{height:'30px',lineHeight:'24px',display:'block'}}>OK</div></div>
                <div style={{width:'80px',display:'inline-block',verticalAlign:'bottom'}} className={'key_btn'} onClick={()=>{retValue()/*setModal('')*/}}><div style={{height:'30px',lineHeight:'30px',display:'block'}}>{localestr('Закрити')}</div></div>
            </div>
            </div>
        </div></div>
    )
}